'use client';

import { datadogRum } from '@datadog/browser-rum';
import { getSession } from 'next-auth/react';

// Add a check to prevent multiple initializations

if (
  !datadogRum.getInternalContext() &&
  process.env.NEXT_PUBLIC_TEST_MODE !== 'true'
) {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID!,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
    site: 'datadoghq.com',
    service: 'haven',
    env: process.env.NODE_ENV!,
    version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    startSessionReplayRecordingManually: true,
  });

  configureUserTracking().catch(() => void 0);
}

async function configureUserTracking() {
  const session = await getSession();
  if (
    session?.user?.email?.endsWith('@findhaven.org') ||
    session?.user?.isLoggedInFromAdmin ||
    session?.user?.admin
  ) {
    //stop tracking for admin users
    datadogRum.setTrackingConsent('not-granted');
    return;
  }
  if (process.env.NODE_ENV === 'production') {
    const random = Math.random();
    if (random < 0.2) {
      datadogRum.startSessionReplayRecording();
    }
  }
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
